import { Apple, Play } from 'lucide-react';

const androidUrl = 'https://play.google.com/store/apps/details?id=in.xagi.ramen';
const iosUrl = 'https://apps.apple.com/us/app/ramen-pocket-size-anime/id6770303367';

export function AppDownloadBanner() {
  return (
    <aside className="app-download-banner" aria-label="Download the app">
      <div>
        <strong>Download the app</strong>
        <span>Watch smoother on iOS and Android.</span>
      </div>
      <nav aria-label="App store links">
        <a href={androidUrl} target="_blank" rel="noreferrer">
          <Play size={14} fill="currentColor" aria-hidden="true" />
          Android
        </a>
        <a href={iosUrl} target="_blank" rel="noreferrer">
          <Apple size={14} fill="currentColor" aria-hidden="true" />
          iOS
        </a>
      </nav>
    </aside>
  );
}
